import {
  Grid,
  Tooltip,
  IconButton,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material'
import ClearAllIcon from '@mui/icons-material/ClearAll'
import { UseFormRegister, FieldValues } from 'react-hook-form'
import { ListViewContext } from '../../../contexts/ListViewContext'
import { useContext } from 'react'

interface FilterControlsProps {
  selected: readonly string[]
  clearFilters(): void
  register: UseFormRegister<FieldValues>
  handleCheckboxChange?: () => void
  deselectCheckboxChange: () => void
}

export function FilterControls({
  selected,
  clearFilters,
  register,
  deselectCheckboxChange,
}: FilterControlsProps) {
  const { showOnlySelected, updateShowOnlySelected } =
    useContext(ListViewContext)

  const handleCheckboxChange = () => {
    updateShowOnlySelected(!showOnlySelected)
  }

  return (
    <Grid container alignItems={'center'} justifyContent={'left'} mt={2}>
      <Tooltip title='Hreinsa síu' sx={{ mr: 1 }} followCursor>
        <IconButton onClick={clearFilters}>
          <ClearAllIcon color='primary' />
        </IconButton>
      </Tooltip>
      <Tooltip title='Birta valdar færslur' followCursor>
        <FormControl>
          <FormGroup {...register('selectedGuids')}>
            <FormControlLabel
              control={
                <Checkbox
                  {...register('showSelected')}
                  checked={showOnlySelected}
                  disabled={!(selected.length > 0)}
                  onChange={handleCheckboxChange}
                />
              }
              label={'Birta valdar færslur'}
            />
          </FormGroup>
        </FormControl>
      </Tooltip>
      <Tooltip title='Afhaka valdar færslur' followCursor>
        <FormControlLabel
          control={
            <Checkbox
              onClick={() => deselectCheckboxChange()}
              checked={selected.length > 0}
              disabled={!(selected.length > 0)}
            />
          }
          label={'Afhaka valdar færslur'}
        />
      </Tooltip>
    </Grid>
  )
}
